// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalCreateQualiphyProcedure_root__3z884","footer":"ModalCreateQualiphyProcedure_footer__4lhvE","additionData":"ModalCreateQualiphyProcedure_additionData__2TOp5"};